module.exports = {"origin":"https://fat-authapi.shui.com.cn","page":"http://fat-portal.shui.com.cn"}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/fat.json
 ** module id = 755
 ** module chunks = 1
 **/